import styled from '@emotion/styled'
import {
    breakpoint,
    breakpointMax,
    calcRem,
    metrics,
} from '../../../../__styling'

export const StyledContainer = styled('div')({
    [breakpoint('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        padding: calcRem(0, metrics.thenightly.margins.xxxxl),
    },
})

export const StyledActionWrapper = styled('div')({
    display: 'flex',
    width: 'fit-content',
    alignSelf: 'flex-end',

    margin: 0,

    [breakpointMax('sm')]: {
        width: '100%',
    },
})
